module.exports = __webpack_public_path__ + "img/pantalla-5-1.1ce930c4.png";